import { render, staticRenderFns } from "./AddStudents.vue?vue&type=template&id=56e35f54"
import script from "./AddStudents.vue?vue&type=script&lang=ts"
export * from "./AddStudents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports